import { cn } from "../lib/utils";

export type MindNode = { label: string; children?: MindNode[] };

const BRANCH = ["border-teal-500 bg-teal-50 text-teal-900 dark:bg-teal-950/40 dark:text-teal-200", "border-amber-500 bg-amber-50 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200",
  "border-sky-500 bg-sky-50 text-sky-900 dark:bg-sky-950/40 dark:text-sky-200", "border-rose-500 bg-rose-50 text-rose-900 dark:bg-rose-950/40 dark:text-rose-200",
  "border-violet-500 bg-violet-50 text-violet-900 dark:bg-violet-950/40 dark:text-violet-200", "border-slate-500 bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-200"];

export function MindMap({ root, highlight }: { root: MindNode; highlight?: string }) {
  const hit = (s: string) => highlight && s.toLowerCase().includes(highlight.toLowerCase());
  return (
    <div className="overflow-x-auto" data-testid="mindmap">
      <div className="flex items-center gap-0 min-w-[820px] py-2">
        <div className="rounded-xl bg-[hsl(var(--sidebar))] text-white px-5 py-4 font-display font-bold text-base shadow-lg shrink-0" data-testid="mindmap-root">{root.label}</div>
        <div className="w-8 h-px bg-border shrink-0" />
        <ul className="flex flex-col gap-3 relative before:absolute before:left-0 before:top-6 before:bottom-6 before:w-px before:bg-border pl-8">
          {(root.children || []).map((b, i) => (
            <li key={b.label} className="relative flex items-center before:absolute before:-left-8 before:top-1/2 before:w-8 before:h-px before:bg-border" data-testid={`mindmap-branch-${i}`}>
              <div className={cn("rounded-lg border-l-4 px-3 py-2 text-sm font-semibold shadow-sm min-w-[190px] shrink-0", BRANCH[i % BRANCH.length], hit(b.label) && "ring-2 ring-primary")}>{b.label}</div>
              {b.children && b.children.length > 0 && (
                <>
                  <div className="w-6 h-px bg-border shrink-0" />
                  <ul className="flex flex-col gap-1.5 relative before:absolute before:left-0 before:top-3 before:bottom-3 before:w-px before:bg-border pl-6">
                    {b.children.map((c) => (
                      <li key={c.label} className="relative before:absolute before:-left-6 before:top-1/2 before:w-6 before:h-px before:bg-border">
                        <span className={cn("inline-block rounded-md border bg-card px-2.5 py-1 text-xs whitespace-nowrap", hit(c.label) && "ring-2 ring-primary font-semibold")}>{c.label}</span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
